import { useLang } from "hooks/useLang"
import fastFacts from "./fastFacts.json"
import fastFacts_ar from "./fastFacts_ar.json"


const FastFact = ({
    title,
    description,
    icon,
}: { title: string; description: string; icon: string }) => {
    return (
        <div className="flex flex-col max-w-[300px] height-auto">
            <div className="flex flex-row gap-2 items-center">
                <img alt={title} src={icon} />
                <div className="text-[22px] dark:text-white light:text-[#000] font-bold break-words">
                    {title}
                </div>
            </div>
            <div>
                <div className="flex flex-row gap-2">
                    <div />
                    <div className="text-[14px] dark:text-white light:text-[#000] font-light whitespace-normal break-words">
                        {description}
                    </div>
                </div>
            </div>
        </div>
    )
}

const RenderFastFacts = () => {
    const { lang } = useLang()
    const data = lang === "ar" ? fastFacts_ar : fastFacts

    return (
        <div className="flex flex-row  h-[110px]">

            {data.map((item, index) => (
                <div key={index} className="w-[300px] min-w-[300px]">
                    <FastFact {...item} />
                </div>

            ))}

        </div>

    )
}

export default RenderFastFacts
